import type { ReactElement } from "react";
import type { PdfInfo } from "./types";

export const PdfLink = ({ title, link }: PdfInfo): ReactElement => (
  <a href={link} target="_blank" rel="noreferrer">
    {title}
  </a>
);
